<nav class="layout-breadcrumb">
  @for (item of breadcrumbs$ | async; track item; let last = $last) {
    <span class="viewname uppercase">{{ item.label | translate }}</span>
  }
</nav>
